module.exports = __webpack_public_path__ + "static/img/back.f2f25b16.png";